import { Button,
  Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

type AdminPanelHeaderProps = {
  onClose: () => void;
  title: string;
}

export const AdminPanelHeader = ({onClose, title}: AdminPanelHeaderProps) => (
  <div className='admin-panel__form-header'>
    <Typography variant="h5">{title}</Typography>
    <Button size="small" endIcon={<Close />} color="primary" variant="contained" onClick={onClose} >Close</Button>
  </div>
)